export default "__VITE_ASSET__DoguMonr__"